import { routePaths } from "../helpers/routePaths";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; // Add this
import { MenuItemLink } from "react-admin";
import { BiUserCircle, BiHomeHeart, BiIdCard, BiCodeAlt } from "react-icons/bi";
import { FaRegFileAlt } from "react-icons/fa";
import { RiAlertLine, RiGroupLine, RiComputerLine } from "react-icons/ri";
import { StoreContext } from "./../store/Store";
import { GiSandsOfTime } from "react-icons/gi";
import { RiAdminLine } from "react-icons/ri";
import { VscTools } from "react-icons/vsc";
import { MdPhotoSizeSelectSmall } from "react-icons/md";
import {
  useHasAnalyticsPermissions,
  useHasLead,
  useHasPermissions,
} from "../hooks/useHasPermissions";
import { PERMISSIONS } from "../roles";
import Box from "@mui/material/Box";
import { sidebarMenu as classes } from "./styles";
import { RiBarChartBoxLine } from "react-icons/ri";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import KioskIcon from "../components/Svg/KioskIcon";


type SidebarMenuProps = {
  onMenuClick: any;
  logout: any;
};

const SidebarMenu = ({ onMenuClick, logout }: SidebarMenuProps) => {
  const [state] = useContext(StoreContext);
  const [subMenu, setSubMenu] = useState<string | null>(null);
  const location = useLocation(); // Add this

  // permissions
  const canViewApi = useHasPermissions(PERMISSIONS.CAN_VIEW_API);
  const canViewInternalApi = useHasPermissions(
    PERMISSIONS.CAN_VIEW_INTERNAL_API
  );
  const canManageAccount = useHasPermissions(PERMISSIONS.CAN_MANAGE_ACCOUNT);
  const canManageLeads = useHasPermissions(PERMISSIONS.CAN_MANAGE_LEADS);
  const canManageBadgeDesign = useHasPermissions(
    PERMISSIONS.CAN_MANAGE_BADGE_DESIGN
  );
  const canManageBadgeSize = useHasPermissions(
    PERMISSIONS.CAN_MANAGE_BADGE_SIZE
  );
  const canManageUser = useHasPermissions(PERMISSIONS.CAN_MANAGE_USER);
  const canManageKiosk = useHasPermissions(PERMISSIONS.CAN_MANAGE_KIOSK);

  const { canViewAnalytics } = useHasAnalyticsPermissions();
  const { leadsInfo, fetchLeadEventData } = useHasLead(state.selectedEvent?.id);
  const handleSubMenuToggle = (key: string) => {
    setSubMenu(subMenu === key ? null : key);
  };

  useEffect(() => {
    if (state.hasLead) {
      fetchLeadEventData();
    }
  }, [state.hasLead]);

  useEffect(() => {
    if (
      location.pathname.includes(routePaths.EXHIBITOR) ||
      location.pathname.includes(routePaths.LEAD_RETRIEVAL_SETTINGS)
    ) {
      setSubMenu(routePaths.EXHIBITOR);
    }
  }, [location]);

  const menuItems = [
    // {
    //   key: `${routePaths.DASHBOARD}`,
    //   text: "Dashboard",
    //   icon: (
    //     <>
    //       <MdDashboard className="icon" size="18" />
    //     </>
    //   ),
    // },
    {
      key: `${routePaths.EDIT}`,
      text: "Event info",
      icon: (
        <>
          <BiHomeHeart className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.BADGE_TEMPLATES}`,
      text: "Badge designer",
      icon: (
        <>
          <BiIdCard className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.BADGE_SIZES}`,
      text: "Badge sizes",
      icon: (
        <>
          <MdPhotoSizeSelectSmall className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.KIOSK_CENTER}`,
      text: "Kiosk Center",
      icon: (
        <>
          <KioskIcon />
        </>
      ),
    },
    {
      key: `${routePaths.ATTENDEES}`,
      text: "Attendees",
      icon: (
        <>
          <RiGroupLine className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.ANALYTICS}`,
      text: "Analytics",
      icon: (
        <>
          <RiBarChartBoxLine className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.ALERT}`,
      text: "Alerts",
      icon: (
        <>
          <RiAlertLine className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.SESSIONS}`,
      text: "Sessions",
      icon: (
        <>
          <GiSandsOfTime className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.EXHIBITOR}`,
      text: "Lead retrieval",
      icon: (
        <>
          <RiComputerLine className="icon" size="18" />
        </>
      ),
      subItems: leadsInfo
        ? [
            {
              key: `${routePaths.EXHIBITOR}`,
              text: "Exhibitors",
            },
            {
              key: `${routePaths.LEAD_RETRIEVAL_SETTINGS}`,
              text: "Settings",
            },
          ]
        : [],
    },
    {
      key: `${routePaths.ACCOUNTS}`,
      text: "Accounts",
      icon: (
        <>
          <RiAdminLine className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.USERS}`,
      text: "Users",
      icon: (
        <>
          <BiUserCircle className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.LOG_PROCESS}`,
      text: "Log process",
      icon: (
        <>
          <FaRegFileAlt className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.SYSADMIN_API_DOCS}`,
      text: "Internal API Docs",
      icon: (
        <>
          <VscTools className="icon" size="18" />
        </>
      ),
    },
    {
      key: `${routePaths.DEVELOPER_API_DOCS}`,
      text: "API Docs",
      icon: (
        <>
          <BiCodeAlt className="icon" size="18" />
        </>
      ),
    },

    // {
    //   key: `${routePaths.MICROSITE}`,
    //   text: "Microsite",
    //   icon: (
    //     <>
    //       <LuScanFace className="icon" size="18" />
    //     </>
    //   ),
    // },

    // NOT IMPLEMENTED FEATURES
    // {
    //   key: `${routePaths.CREDITS}`,
    //   text: "Credits",
    //   icon: (
    //     <>
    //       <BiCreditCard className="icon" size="18" />
    //     </>
    //   ),
    // },
    // {
    //   key: `${routePaths.ZENDESK}`,
    //   text: "Zendesk",
    //   icon: (
    //     <>
    //       <BiInfoCircle className="icon" size="18" />
    //     </>
    //   ),
    // },
    // {
    //   key: `${routePaths.HINTS}`,
    //   text: "Tips and hints",
    //   icon: (
    //     <>
    //       <BiBulb className="icon" size="18" />
    //     </>
    //   ),
    // },
  ];

  const handleMenuClick = () => {
    setSubMenu(null);
    onMenuClick as any;
  };

  const getMenuItemPath = (itemKey: string) => {
    switch (itemKey) {
      case routePaths.USERS:
        return canManageUser ? `/${routePaths.USERS}` : null;
      case routePaths.CREDITS:
        return `/${routePaths.CREDITS}`;
      case routePaths.ZENDESK:
        return `/${routePaths.ZENDESK}`;
      case routePaths.HINTS:
        return `/${routePaths.HINTS}`;
      case routePaths.ACCOUNTS:
        return canManageAccount ? `/${routePaths.ACCOUNTS}` : null;
      case routePaths.DEVELOPER_API_DOCS:
        return canViewApi ? `/${routePaths.DEVELOPER_API_DOCS}` : null;
      case routePaths.SYSADMIN_API_DOCS:
        return canViewInternalApi ? `/${routePaths.SYSADMIN_API_DOCS}` : null;
      case routePaths.BADGE_SIZES:
        return canManageBadgeSize ? `/${routePaths.BADGE_SIZES}` : null;
      case routePaths.BADGE_TEMPLATES:
        return canManageBadgeDesign && state.selectedEvent
          ? `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.BADGE_TEMPLATES}`
          : null;
      case routePaths.ALERT:
        return canManageUser && state.selectedEvent
          ? `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${itemKey}`
          : null;
      case routePaths.ANALYTICS:
        return canViewAnalytics && state.selectedEvent
          ? `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${itemKey}`
          : null;
      case routePaths.EXHIBITOR:
        return state.selectedEvent
          ? `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${itemKey}`
          : null;
      case routePaths.LOG_PROCESS:
        return canManageAccount && state.selectedEvent
          ? `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${itemKey}`
          : null;
      case routePaths.KIOSK_CENTER:
        return canManageKiosk && state.selectedEvent
          ? `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${itemKey}`
          : null;
      default:
        return state.selectedEvent
          ? `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${itemKey}`
          : null;
    }
  };

  return (
    <Box sx={classes.wrapper} aria-label="menu-wrapper">
      {menuItems
        .filter((item) => getMenuItemPath(item.key) !== null)
        .map((item) => {
          const menuItemPath = getMenuItemPath(item.key);
          const isOpen = subMenu === item.key;
          return (
            <Box key={item.key} sx={{ width: "250px" }}>
              <Box sx={{ display: "flex", width: "250px" }}>
                <MenuItemLink
                  to={
                    item.subItems !== undefined && item.subItems.length !== 0
                      ? "#"
                      : (menuItemPath as string)
                  } // Prevent navigation for subitems
                  primaryText={
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Box>{item.text}</Box>
                      {item.subItems !== undefined &&
                        item.subItems.length !== 0 && (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            {isOpen ? <ExpandLess /> : <ExpandMore />}
                          </Box>
                        )}
                    </Box>
                  }
                  leftIcon={item.icon}
                  onClick={() =>
                    item.subItems !== undefined
                      ? handleSubMenuToggle(item.key)
                      : handleMenuClick()
                  }
                  sx={{ width: "250px" }}
                />
              </Box>
              {item.subItems && isOpen && (
                <Box sx={{ pl: 6 }}>
                  {item.subItems.map((subItem: any) => {
                    const subMenuItemPath = getMenuItemPath(subItem.key);
                    return (
                      <MenuItemLink
                        key={subItem.key}
                        to={subMenuItemPath as string}
                        primaryText={subItem.text}
                        onClick={onMenuClick}
                      />
                    );
                  })}
                </Box>
              )}
            </Box>
          );
        })}
      {/* <Responsive small={logout} medium={undefined} /> */}
    </Box>
  );
};

export default SidebarMenu;
export { routePaths };
